import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSupport: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSupport"><Path d="M5.52248 9C5.79665 5.96122 8.54637 3.5 12 3.5C15.4536 3.5 18.2034 5.96122 18.4775 9H17.5V17H18.7418C18.6132 18.9545 16.9871 20.5 15 20.5H12.75V18.8929H11.25V22H15C17.8342 22 20.1438 19.7542 20.2464 16.9451C21.2502 16.719 22 15.8221 22 14.75V11.25C22 10.0862 21.1164 9.12877 19.9835 9.01197C19.7144 5.05436 16.196 2 12 2C7.80404 2 4.28555 5.05436 4.01653 9.01197C2.88359 9.12877 2 10.0862 2 11.25V14.75C2 15.9926 3.00736 17 4.25 17H6.5V9H5.52248Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSupport;
